export default {
  title: 'Chat Bot',
  tab: 'CHATBOT'
}
